// extracted by mini-css-extract-plugin
export var cartIcon = "_jp-0";
export var cartIconContainer = "_jp-1";